import React, { useState, createContext, useContext } from 'react';
export type ViewMode = 'brand' | 'store';
export interface Location {
  id: string;
  name: string;
  code: string;
  city: string;
}
interface ViewModeContextType {
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
  currentLocation: Location | null;
  setCurrentLocation: (location: Location | null) => void;
  locations: Location[];
  // Brand view location filter
  selectedBrandLocations: string[]; // 'all' or array of location codes
  setSelectedBrandLocations: (locations: string[]) => void;
  isAllLocationsSelected: boolean;
  isSingleLocationSelected: boolean;
  getSelectedLocationData: () => Location | null;
}
// Mock locations data
const MOCK_LOCATIONS: Location[] = [{
  id: '1',
  name: 'Mumbai Motors',
  code: 'MH401',
  city: 'Mumbai'
}, {
  id: '2',
  name: 'Delhi Auto Hub',
  code: 'DL302',
  city: 'Delhi'
}, {
  id: '3',
  name: 'Pune Motors',
  code: 'MH201',
  city: 'Pune'
}, {
  id: '4',
  name: 'Koncept Auto',
  code: 'HR407',
  city: 'Gurugram'
}, {
  id: '5',
  name: 'Chennai Cars',
  code: 'TN101',
  city: 'Chennai'
}];
const ViewModeContext = createContext<ViewModeContextType | undefined>(undefined);
export function ViewModeProvider({
  children
}: {
  children: ReactNode;
}) {
  const [viewMode, setViewMode] = useState<ViewMode>('brand');
  const [currentLocation, setCurrentLocation] = useState<Location | null>(MOCK_LOCATIONS[0]);
  const [selectedBrandLocations, setSelectedBrandLocations] = useState<string[]>(['all']);
  const isAllLocationsSelected = selectedBrandLocations.includes('all');
  const isSingleLocationSelected = !isAllLocationsSelected && selectedBrandLocations.length === 1;
  const getSelectedLocationData = (): Location | null => {
    if (isSingleLocationSelected) {
      return MOCK_LOCATIONS.find(loc => loc.code === selectedBrandLocations[0]) || null;
    }
    return null;
  };
  return <ViewModeContext.Provider value={{
    viewMode,
    setViewMode,
    currentLocation,
    setCurrentLocation,
    locations: MOCK_LOCATIONS,
    selectedBrandLocations,
    setSelectedBrandLocations,
    isAllLocationsSelected,
    isSingleLocationSelected,
    getSelectedLocationData
  }} data-id="element-1745">
      {children}
    </ViewModeContext.Provider>;
}
export function useViewMode() {
  const context = useContext(ViewModeContext);
  if (!context) {
    throw new Error('useViewMode must be used within ViewModeProvider');
  }
  return context;
}